import { render, staticRenderFns } from "./DraftOrdersDropdown.vue?vue&type=template&id=25cdd626&scoped=true&"
import script from "./DraftOrdersDropdown.vue?vue&type=script&lang=js&"
export * from "./DraftOrdersDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DraftOrdersDropdown.vue?vue&type=style&index=0&id=25cdd626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cdd626",
  null
  
)

export default component.exports